module.exports = __webpack_public_path__ + "20be4b6b9257e4dcc3bd0ad5104390f2.svg";